import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["details", "checkbox"]

  connect() {
    this.toggleDetails()
  }

  toggleDetails() {
    // toggle switch to hide and clear out field values when checkbox is checked
    // or show empty fields when checkbox is unchecked
    if (this.checkboxTarget.checked) {
      this.detailsTarget.classList.add("hidden")

      const fields = this.detailsTarget.querySelectorAll("input, select, textarea")
      fields.forEach((field) => {
        if (field.type === "checkbox" || field.type === "radio") {
          field.checked = false
        } else {
          field.value = ""
        }
      })
    } else {
      this.detailsTarget.classList.remove("hidden")
    }
  }
}
